export default {
    props: {
        playbookId: Number,
        playbooksRepository: {
            type: Object,
            default: () => {
                return new (require("@/js/repositories/playbooks.js"))();
            },
        },
    },
    data() {
        return {
            playbook: null,
            loading: false,
            savingPlaybook: false,
        };
    },
    created() {
        if (this.playbookId) {
            this.mixinPlaybook_loadPlaybook();
        }
    },
    watch: {
        playbookId() {
            if (this.playbookId) {
                this.mixinPlaybook_loadPlaybook();
            }
        },
    },
    methods: {
        mixinPlaybook_clear() {
            this.playbook = null;
            this.loading = false;
            this.savingPlaybook = false;
        },
        async mixinPlaybook_loadPlaybook() {
            this.mixinPlaybook_clear();
            await this.mixinPlaybook_query();
        },
        async mixinPlaybook_query() {
            this.loading = true;
            const response = await this.playbooksRepository.show(
                this.playbookId
            );
            this.loading = false;
            this.playbook = response.data.data;
        },
        async mixinPlaybook_savePlaybook(data) {
            this.savingPlaybook = true;
            let response = await this.playbooksRepository
                .update(this.playbookId, data)
                .catch((e) => {
                    this.savingPlaybook = false;
                });
            this.savingPlaybook = false;
            this.playbook = response.data.data;
            this.$Message.success({
                content: "Playbook saved.",
                closable: true,
            });
        },
        async mixinPlaybook_deletePlaybook(id) {
            this.savingPlaybook = true;
            return await this.playbooksRepository
                .remove(this.playbookId)
                .catch((e) => {
                    this.savingPlaybook = false;
                });
        },
    },
};
